import {Grid, makeStyles} from '@yandex-delivery/blocks'
import type {ContentHeaderItem} from 'src/api/types'

type Props = {
  item: ContentHeaderItem
}

const useClasses = makeStyles(
  theme => ({
    title: {
      margin: `0 -${theme.spacing(1)}px`,
      padding: `0 ${theme.spacing(1)}px`,
      fontSize: '13px',
      fontWeight: 500,
      lineHeight: '24px',
      color: 'var(--colorScheme-textMinor, #9e9b98)',
      borderRadius: 6,
      backgroundColor: 'var(--colorScheme-bgMinor, #f5f4f2)',
    },
  }),
  {name: 'Header'},
)

export const Header: React.FC<Props> = ({item}) => {
  const classes = useClasses()

  return <Grid className={classes.title}>{item.title.text}</Grid>
}
